<template>
    <div class="tpl-page-container"  style="padding: 0;">
        <MainView></MainView>
    </div>
</template>

<script type="text/javascript">
    import MainView from '@/apps/plan/mobile_page/plan_mobile_edit.vue'

    import {mapActions} from 'vuex'
    import {mapState} from 'vuex'

    export default {
        components: {
            MainView,
        },
        computed: {
            ...mapState({
                view_id: state => state.main.view_id
            })
        },
        methods: {
            ...mapActions({
                change_main_view: 'main/change_main_view'
            })
        },
        watch: {
            '$route': function () {
                this.change_main_view(this.$route.params.view_id)
                //     this.change_index_content(),
                // this.change_dashboard_content(this.$route.query)
            }
        },
        mounted: function () {
            this.change_main_view(this.$route.params.view_id)
        }
    }
</script>
<style type="text/css">
</style>
